import React from 'react';
import { WebsiteList } from '../components/Website';

const WebsitesPage = () => (
    <div>
        <h1>Websites</h1>
        <WebsiteList />
    </div>
);

export default WebsitesPage;